class TabbedProductGrid extends HTMLElement {
  constructor() {
    super();
    this.movingBlockTab = this.querySelector("moving-block-tab");
    this.swiperEl = this.querySelector("[data-swiper]");
  }
  connectedCallback() {
    this.swiper = new Swiper(this.swiperEl, {
        allowTouchMove: false,
        autoHeight: true
    });
    this.movingBlockTab.addEventListener("moving-block-tab:switch", e=>{
        console.log("moving-block-tab:switch", e.detail.index);
        this.swiper.slideTo(e.detail.index);
    })

  }
}
if (!customElements.get("tabbed-product-grid")) {
  customElements.define("tabbed-product-grid", TabbedProductGrid);
}
